





































import Vue from 'vue'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import BorderButton from '@/components/border-button.vue'

type Prop<T> = () => T
export interface Client {
  oneLetter: string
  clientName: string
  clientDescription: string
  clientSite: string
  gallery: Array<{ src: string; caption: string }> 
  projects: Array<{ name: string; url: string }>
  designSelectionAward: boolean
}

export default Vue.extend({
  props: {
    client: Object as Prop<Client>
  },

  components: {
    'Swiper': swiper,
    'SwiperSlide': swiperSlide,
    BorderButton
  },

  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: true
        }
      }
    }
  },

  computed: {
    clientExist() {
      // @ts-ignore
      return Object.keys(this.client).length > 0
    }
  },

  mounted() {
    if (!this.clientExist) return
    if (this.client.gallery.length < 2) return

    // @ts-ignore
    const imgs: HTMLImageElement[] = Array.from(this.$refs.gallery.$el.querySelectorAll('img'))
    // @ts-ignore
    const promises: Promise<void>[] = imgs.map(img => {
      return new Promise((resolve, reject) => {
        img.addEventListener('load', () => resolve())
        img.addEventListener('error', () => reject())
      })
    })
    // @ts-ignore
    (Promise as any).allSettled(promises).then(() => {
      // @ts-ignore
      this.$refs.gallery.swiper.update()
    })
  }
})
